'use client';

import { toast, Toaster } from 'sonner';
import { Icon } from './Icon';
import { Spinner } from './Spinner';

const UpdatingToast = ({ text = 'Updating' }) => {
  return (
    <div className="flex items-center gap-3 bg-gray-50 text-gray-800 rounded-full p-2.5 shadow-md">
      <Spinner size="2" />
      <span className="text-sm">{text}</span>
    </div>
  );
};

const UpdatedToast = ({ text = 'Updated!' }) => {
  return (
    <div className="flex items-center gap-3 bg-gray-50 text-gray-800 rounded-full p-2.5 shadow-md">
      <Icon name="notification-success" className="w-5 h-5 text-[#00E73E]" />
      <span className="text-sm">{text}</span>
    </div>
  );
};

const ErrorToast = ({ text = 'Error. Check your connection' }) => {
  return (
    <div className="flex items-center gap-3 bg-red-error text-white rounded-full p-2.5 shadow-md w-full">
      <Icon name="notification-error" className="w-5 h-5" />
      <span className="text-sm">{text}</span>
    </div>
  );
};

const TipToast = ({ text = 'Error. Check your connection' }) => {
  return (
    <div className="flex items-center gap-3 bg-white text-black rounded-full p-2.5 shadow-md w-full">
      <Icon name="hint" className="size-5" />
      <span className="text-sm">{text}</span>
    </div>
  );
};

const SuccessToast = ({ text = 'Success' }) => {
  return (
    <div className="flex items-center gap-3 bg-white rounded-full p-2.5 shadow-md">
      <Icon name="partner" className="w-5 h-5" />
      <span className="text-sm">{text}</span>
    </div>
  );
};

export const useToast = () => {
  const dismiss = (id?: string) => {
    if (id) {
      toast.dismiss(id);
    } else {
      toast.dismiss('updating');
    }
  };
  const showUpdating = (text?: string) => {
    return toast.custom((t) => <UpdatingToast text={text} />, {
      duration: Infinity,
      id: 'updating',
    });
  };

  const showUpdated = (text?: string) => {
    toast.dismiss('updating');
    return toast.custom((t) => <UpdatedToast text={text} />, {
      duration: 3000,
    });
  };

  const showError = (text?: string) => {
    toast.dismiss('updating');
    return toast.custom((t) => <ErrorToast text={text} />, {
      duration: 5000,
    });
  };

  const showSuccess = (text?: string) => {
    return toast.custom((t) => <SuccessToast text={text} />, {
      duration: 5000,
    });
  };

  const showTip = (text?: string) => {
    return toast.custom((t) => <TipToast text={text} />, {
      duration: 5000,
    });
  };

  return {
    updating: showUpdating,
    updated: showUpdated,
    error: showError,
    tip: showTip,
    success: showSuccess,
    dismiss,
  };
};
